import { Flex } from "@mantine/core";
import { Avatar } from "@onengine/component-library";
import TextCellWithConditionalTooltip from "../TextCellWithConditionalTooltip/TextCellWithConditionalTooltip";

type TableCellWithAvatarProps = {
  name: string;
};

const TableCellWithAvatar = ({ name }: TableCellWithAvatarProps) => {
  return (
    <Flex component="span" align="center" gap="var(--spacing-3x-small)">
      <Avatar type="initials" name={name ?? undefined} />
      <TextCellWithConditionalTooltip text={name ?? undefined} />
    </Flex>
  );
};

export default TableCellWithAvatar;
